import { createFileRoute } from "@tanstack/react-router";
import LegalNotice from "@/pages/LegalNotice";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/legal-notice")({
  head: () => pageHead("legalNotice", "en"),
  component: LegalNotice,
});
